import i18next from 'i18next'

i18next.addResourceBundle('en', 'pat', {
    title: 'Personal Access Tokens',
    description: 'Personal access tokens allow you to authenticate with OpenL Studio APIs without using your password. They are useful for scripts, integrations, and automated tools.',
    create_token: 'Create Token',
    token_name: 'Token Name',
    token_name_placeholder: 'e.g., CI/CD Pipeline, MCP Client',
    expiration: 'Expiration',
    expiration_placeholder: 'Select expiration date (optional)',
    no_expiration: 'No expiration',
    expires_at: 'Expires',
    created_at: 'Created',
    never: 'Never',
    expired: 'Expired',
    actions: 'Actions',
    delete: 'Delete',
    delete_confirm_title: 'Delete Token',
    delete_confirm_message: 'Are you sure you want to delete the token "{{name}}"? This action cannot be undone and any applications using this token will no longer be able to authenticate.',
    no_tokens: 'No personal access tokens',
    no_tokens_description: 'You have not created any personal access tokens yet. Create one to get started.',
    token_created_title: 'Token Created Successfully',
    token_created_message: 'Your new personal access token has been created. Make sure to copy it now - you will not be able to see it again!',
    token_copied: 'Token copied to clipboard',
    usage_hint: 'Use this token in your API requests:',
    validation: {
        name_required: 'Token name is required',
        name_max_length: 'Token name must not exceed 100 characters',
    },
    expiration_options: {
        '7_days': '7 days',
        '30_days': '30 days',
        '60_days': '60 days',
        '90_days': '90 days',
        custom: 'Custom date',
        no_expiration: 'No expiration',
    },
})
